import Call from '../Call';
import { objToQs } from '../Utils';

const MasterCron = {
    get(countries) {
        let params = { countries: countries.join(',') };

        return Call(`https://wbidder.online/cpc?${objToQs(params)}`, 'GET', {}, true);
    }
}

export default MasterCron;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderCPC.js